import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.scss";
import ViewIcon from "../../../assets/Header/viewIcon.svg";
import { Empty, Modal, Spin, Tooltip } from "antd";
import Button from "../../../common/Button";
import BackIcon from "../../../assets/Header/backIcon.svg";

import {
  useGetAllMarketPlace,
  useGetAllMarketPlaceCategories,
  useGetAllMarketPlaceSubCategories,
  useGetAllMergedGuidelines,
} from "../../../hooks/useGuidelines";

import { useNavigate, useParams } from "react-router-dom";
import chevronImage from "../../../assets/Sequencing/chevron.svg";
import "./style.scss";
import SequentialDetail from "../../Guidelines/SequentialDetail";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";
import { BatchMarketPlaceContext } from "../../../context/batchProvider";
import Stepper from "../../Stepper";

const Sequencing = ({ isViewOnly }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [angleSets, setAngleSets] = useState([]);
  const [marketPlaceSubCategoryList, setMarketPlaceSubCategoryList] = useState(
    []
  );
  const [marketPlaceList, setMarketPlaceList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [selectedDeleteId, setSelectedDeleteId] = useState("");
  const [isAngleSetDetails, setIsAngleSetDetails] = useState(false);
  const [angleSetDetails, setAngleSetDetails] = useState([]);
  const [selectedMarketplaceId, setSelectedMarketplaceId] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const { guide_setSelectedGuidelLineId, guide_selectedClientId } = useContext(
    GuidelinesSelectedCategoryContext
  );

  const { batch_selectedMarketPlaces, batch_skipPages } = useContext(
    BatchMarketPlaceContext
  );
  const navigate = useNavigate();
  const selectedCatgeoryRef = useRef(null);
  const selectedMarketPlaceRef = useRef(null);
  const selectedAllMarketPlaceRef = useRef(null);
  const clientRef = useRef(null);
  const [showCategoryItems, setShowCategoryItems] = useState(true);
  const [showListItems, setShowListItems] = useState(true);
  const params = useParams();
  useEffect(() => {
    if (selectedCatgeoryRef.current) {
      selectedCatgeoryRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (selectedMarketPlaceRef.current) {
      selectedMarketPlaceRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (selectedAllMarketPlaceRef.current) {
      selectedAllMarketPlaceRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (clientRef.current) {
      clientRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedCategoryId, selectedSubCategoryId, selectedMarketplaceId]);

  useEffect(() => {
    if (!isViewOnly) {
      setSelectedMarketplaceId(batch_selectedMarketPlaces[0]?.id);
    } else {
      setSelectedMarketplaceId(marketPlaceList[0]?._id);
    }
  }, [marketPlaceList, batch_selectedMarketPlaces]);

  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  const onSuccessGetAllCategories = (data) => {
    setCategoryList(data?.data?.data);
  };
  const onErrorGetAllCategories = () => {};

  const { data: getCategories, refetch: refetchList } =
    useGetAllMarketPlaceCategories(
      "getCategories",
      selectedMarketplaceId,
      null,
      onSuccessGetAllCategories,
      onErrorGetAllCategories
    );

  const onSuccessGetAllMarketPlaceSubCategories = (data) => {
    setMarketPlaceSubCategoryList(data?.data?.data);
  };
  const onErrorGetAllMarketPlaceSubCategories = () => {};

  const { data: getSubCategories, refetch: refetchMarketPlaceSubCategories } =
    useGetAllMarketPlaceSubCategories(
      "getSubCategories",
      selectedCategoryId,
      selectedMarketplaceId,
      guide_selectedClientId,
      onSuccessGetAllMarketPlaceSubCategories,
      onErrorGetAllMarketPlaceSubCategories
    );

  const onSuccessGetAllMergedGuidelines = (res) => {
    if (res) {
      setAngleSets(res?.data?.data?.angleSets);
      guide_setSelectedGuidelLineId(res?.data?.data?._id);
    }
  };
  const onErrorGetAllMergedGuidelines = () => {};
  const {
    data: getMergedGuideline,
    refetch: refetchGuidelines,
    isLoading,
  } = useGetAllMergedGuidelines(
    "getCategories",
    selectedCategoryId,
    selectedSubCategoryId,
    selectedMarketplaceId,
    onSuccessGetAllMergedGuidelines,
    onErrorGetAllMergedGuidelines
  );

  const onSuccessGetAllMarketPlace = (data) => {
    setMarketPlaceList(data?.data?.data);
  };

  const onErrorGetAllMarketPlace = (err) => {
    console.log(err.message);
  };

  const { data: getAllMarketPlace, refetch: refetchMarketPlaceList } =
    useGetAllMarketPlace(
      "getAllSubCategories",
      guide_selectedClientId,
      pageNum,
      pageSize,
      onSuccessGetAllMarketPlace,
      onErrorGetAllMarketPlace
    );
  const getAngleSetDetailsModal = () => {
    return (
      <Modal
        title="Angles Set Details"
        open={isAngleSetDetails}
        footer={null}
        width="90%"
        height="90dvh"
        className="angle_set_details_modal_wrapper"
        onCancel={() => setIsAngleSetDetails(false)}
      >
        <SequentialDetail isDisabled={true} imageData={angleSetDetails} />
      </Modal>
    );
  };

  const getCategory = () => {
    return (
      <div className="category_wrapper">
        <div className="title">
          <h6>Category</h6>
          <img
            src={chevronImage}
            alt=""
            className={
              showCategoryItems ? "chevron_image rotate" : "chevron_image"
            }
            onClick={() => setShowCategoryItems(!showCategoryItems)}
          />
        </div>

        {showCategoryItems && (
          <div className="list">
            {categoryList?.length > 0 &&
              categoryList
                .filter((item) => {
                  if (!searchName?.trim()) {
                    return true;
                  }
                  const regex = new RegExp(
                    `\\b${searchName.toLowerCase()}\\b`,
                    "i"
                  );
                  return (
                    item?.name
                      ?.toLowerCase()
                      .includes(searchName.toLowerCase()) ||
                    regex.test(item?.name?.toLowerCase())
                  );
                })
                .map((category, index) => {
                  const isSelected = selectedCategoryId === category?._id;
                  return (
                    <button
                      className={`categoryBtn ${
                        isSelected ? "activeCategory" : ""
                      }`}
                      key={index}
                      ref={isSelected ? selectedCatgeoryRef : null}
                      onClick={() => {
                        if (!isSelected) {
                          setSelectedCategoryId(category?._id);
                          setSelectedSubCategoryId("");
                          setAngleSets([]);
                        }
                      }}
                    >
                      <div className="image_wrapper_box">
                        <img src={category?.image?.thumbPath?.url} alt="" />
                      </div>
                      <div className="text_wrapper">
                        {category?.name?.length > 15 ? (
                          <Tooltip title={category?.name} placement="rightTop">
                            {truncateText(category?.name, 15)}
                          </Tooltip>
                        ) : (
                          category?.name
                        )}
                      </div>
                    </button>
                  );
                })}
          </div>
        )}
      </div>
    );
  };
  const getSubCategory = () => {
    return (
      <div className="subCategory_wrapper">
        <div className="title">
          <h6>Sub Category</h6>
          <img
            src={chevronImage}
            alt=""
            className={showListItems ? "chevron_image rotate" : "chevron_image"}
            onClick={() => setShowListItems(!showListItems)}
          />
        </div>

        {showListItems && (
          <div className="list">
            {marketPlaceSubCategoryList?.length > 0 && selectedCategoryId ? (
              marketPlaceSubCategoryList?.map((item, index) => {
                return (
                  <button
                    className={`categoryBtn ${
                      selectedSubCategoryId === item?._id
                        ? "activeCategory"
                        : ""
                    }`}
                    key={index}
                    ref={
                      item?._id === selectedSubCategoryId
                        ? selectedMarketPlaceRef
                        : null
                    }
                    onClick={() => {
                      setSelectedSubCategoryId(item?._id);
                    }}
                  >
                    <div className="image_wrapper_box">
                      <img src={item?.image?.thumbPath?.url} alt="" />
                    </div>
                    <div className="text_wrapper">
                      {item?.name?.length > 15 ? (
                        <Tooltip title={item?.name} placement="rightTop">
                          {truncateText(item?.name, 15)}
                        </Tooltip>
                      ) : (
                        item?.name
                      )}
                    </div>
                  </button>
                );
              })
            ) : marketPlaceSubCategoryList?.length === 0 &&
              selectedCategoryId ? (
              <div className="empty_container">
                <Empty description={"No Sub Category Found"} />
              </div>
            ) : (
              !selectedCategoryId && (
                <div className="empty_container">
                  <Empty
                    description={"Select Category to view its Sub Categories"}
                  />
                </div>
              )
            )}
          </div>
        )}
      </div>
    );
  };

  const handleNext = () => {
    if (batch_skipPages.includes("addOnService")) {
      navigate(`/upload-images/${params?.batchId}`, {
        state: {
          from: "sequencing",
        },
      });
    } else {
      navigate(`/add-on-services/${params.batchId}`);
    }
  };

  const getSetsList = () => {
    return (
      <div className="sets_main_wrapper">
        <div className="sets_content">
          <div className="sets_main_container">
            {isLoading ? (
              <div className="loading_container">
                <Spin size="large" />
              </div>
            ) : angleSets?.length > 0 ? (
              angleSets?.map((item, index) => {
                return (
                  <div className="sets_card_wrapper" key={index}>
                    <div className="sets_card_content">
                      <div className="sets_header">
                        <div className="title">
                          Set {index + 1} ({item?.angles?.length}{" "}
                          {item?.angles?.length === 1 ? "Image" : "Images"})
                        </div>
                        <div className="action_wrapper">
                          <div className="view_icon_wrapper">
                            <img
                              src={ViewIcon}
                              alt="ViewIcon"
                              onClick={() => {
                                setIsAngleSetDetails(true);
                                setAngleSetDetails(item.angles);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="sets_images_list">
                        {item?.angles?.length > 0 &&
                          item?.angles.map((angle, index) => {
                            return (
                              <div className="image_wrapper" key={index}>
                                <div className="shoot_type_wrapper">
                                  {angle?.angleGlobal?.shootType}
                                </div>
                                <div className="image_container">
                                  <img
                                    src={
                                      angle?.angleGlobal?.image?.thumbPath?.url
                                    }
                                    alt=""
                                  />
                                </div>
                                <span>{angle?.adaptation?.name}</span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : !selectedCategoryId && !selectedSubCategoryId ? (
              <div className="empty_container">
                <Empty
                  description={
                    "Select a category and subcategory to view the angle set."
                  }
                />
              </div>
            ) : selectedCategoryId && selectedSubCategoryId ? (
              <div className="empty_container">
                <Empty
                  description={
                    "No angle sets found create a new set to view here"
                  }
                />
              </div>
            ) : (
              selectedCategoryId &&
              !selectedSubCategoryId && (
                <div className="empty_container">
                  <Empty
                    description={
                      "Select a subcategory to view the angle sets here"
                    }
                  />
                </div>
              )
            )}
          </div>
          <div className="bottom_panel">
            {!isViewOnly && (
              <Stepper
                activeStep={3}
                nextStep={`/add-on-services`}
                backStep={"/select-marketplace"}
                isSeggregation={false}
              />
            )}
            {!isViewOnly && (
              <div className="action_wrapper">
                <button
                  className="backBtn"
                  onClick={() =>
                    navigate(`/select-marketplace/${params.batchId}`)
                  }
                >
                  <img src={BackIcon} alt="backBtn" />
                </button>
                <Button
                  text="Next"
                  width="140px"
                  height="50px"
                  handleClick={() => handleNext()}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const getMarketPlaceSection = () => {
    return (
      <div className="market_place_container">
        <div className="title">
          <h6>Marketplace</h6>
        </div>
        {isViewOnly ? (
          <div className="list">
            {marketPlaceList?.map((category, index) => {
              return (
                <div className="market_wrapper">
                  <button
                    className={`categoryBtn ${
                      selectedMarketplaceId === category?._id
                        ? "activeCategory"
                        : ""
                    }`}
                    key={`${category?._id}{index}${index}`}
                    ref={
                      category?._id === selectedMarketplaceId
                        ? selectedAllMarketPlaceRef
                        : null
                    }
                    onClick={() => {
                      setSelectedMarketplaceId(category?._id);
                      setSelectedCategoryId("");
                      setSelectedSubCategoryId("");
                      setAngleSets([]);
                    }}
                  >
                    {category.name}
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="list">
            {batch_selectedMarketPlaces?.map((marketplace, index) => {
              return (
                <div className="market_wrapper">
                  <button
                    className={`categoryBtn ${
                      selectedMarketplaceId === marketplace?.id
                        ? "activeCategory"
                        : ""
                    }`}
                    key={marketplace?.id}
                    ref={
                      marketplace?.id === selectedMarketplaceId
                        ? selectedAllMarketPlaceRef
                        : null
                    }
                    onClick={() => {
                      setSelectedMarketplaceId(marketplace?.id);
                      setSelectedCategoryId("");
                      setSelectedSubCategoryId("");
                      setAngleSets([]);
                    }}
                  >
                    {marketplace.name}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="sequencing_main_container">
      <div className="col_one">
        {getMarketPlaceSection()}
        {getCategory()}
        {getSubCategory()}
      </div>
      <div className="col_three">{getSetsList()}</div>
      {isAngleSetDetails && getAngleSetDetailsModal()}
    </div>
  );
};
export default Sequencing;
